import { Button, Form, Input, Select, Space } from "antd";
import UsersApi from "Api/UsersApi/UsersApi";
import { MyLoader } from "Components/MyLoader/MyLoader";
import {
  errorNotification,
  successNotification,
} from "Components/MyNotification";
import { MyText } from "Components/MyText/MyText";
import React, { useEffect, useState } from "react";
import { CopyOutlined } from "@ant-design/icons";
export const UpdateUserForm = ({ form, userId, roles = [], onFinish }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [inviteLink, setInviteLink] = useState(null);
  const [isCopied, setIsCopied] = useState(false);

  const generateInvite = async () => {
    try {
      setIsLoading(true);
      const result = await UsersApi.generateLink(userId);
      if (result.status === "fail") {
        errorNotification(result.message);
        return;
      }
      if (result.status === "success") {
        const link = result.dto;
        setInviteLink(link);
        return;
      }
    } catch (err) {
      errorNotification(err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    setInviteLink(null);
    setIsCopied(false);
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const result = await UsersApi.getSingleUser(userId);
        if (result.status === "fail") {
          errorNotification(result.message);
          return;
        }
        if (result.status === "success") {
          const userData = result.dto;
          form.setFieldsValue({
            name: userData.name,
            email: userData.email,
            roles: userData.roles.map((r) => r.id),
          });
          return;
        }
      } catch (err) {
        errorNotification(err);
      } finally {
        setIsLoading(false);
      }
    };
    if (userId) {
      fetchData();
    }
  }, [userId]);
  if (isLoading) {
    return <MyLoader centered />;
  }

  return (
    <>
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Form.Item
          label="Ім'я"
          name="name"
          rules={[
            { required: true, message: "Введіть ім'я користувача" },
            { min: 6, message: "Мінімум 6 символів" },
          ]}
        >
          <Input placeholder="Наприклад: Сидоренко Тетяна" />
        </Form.Item>

        <Form.Item
          label="Пароль"
          name="password"
          normalize={(value) => value?.trim()}
        >
          <Input.Password placeholder="Введіть пароль" />
        </Form.Item>

        <Form.Item
          label="Email"
          name="email"
          normalize={(value) => value?.trim().toLowerCase()}
          rules={[
            { required: true, message: "Введіть email" },
            { type: "email", message: "Некоректний email" },
          ]}
        >
          <Input placeholder="example@gmail.com" />
        </Form.Item>

        <Form.Item label="Доступи" name="roles">
          <Select
            mode="multiple"
            placeholder="Оберіть ролі"
            allowClear
            options={roles.map((r) => ({
              label: r.role,
              value: r.id,
            }))}
          />
        </Form.Item>
      </Form>
      <Space style={{ display: "flex", flexDirection: "column" }}>
        {!inviteLink ? (
          <Button type="primary" onClick={generateInvite} loading={isLoading}>
            Згенерувати новий Telegram Invite
          </Button>
        ) : (
          <MyText text={inviteLink}>
            {!isCopied && (
              <Button
                onClick={async () => {
                  await navigator.clipboard.writeText(inviteLink);
                  setIsCopied(true);
                  successNotification("Посилання скопійовано");
                }}
              >
                <CopyOutlined />
              </Button>
            )}
          </MyText>
        )}
      </Space>
    </>
  );
};
